import * as z from "zod";
import { decimal } from "../index";

export { code, codeName, version } from "../index";

// Pieces of schema more than one feature of the catalog uses; not part of `@nexxt/contracts/catalog`.

export const currencyCode = z.string().length(3);

/** Percentage points as decimal text (`"12.5"` is 12.5%), as a `numeric(7,4)` column holds them. */
export const pct = decimal.refine((v) => Number(v) >= 0 && Number(v) < 1000, "A percentage between 0 and 999.9999");

/** What tells a style-colour from the others, the same in the form of a line and in the files that name one. */
export const styleCode = z.string().trim().min(1).max(60);
export const colourDescription = z.string().trim().max(200);

/**
 * Tomorrow's codes of a style-colour, the ones its SKU codes are made of (`<item>-<colour>-<size>`, as on NetSuite,
 * ADR-188): letters and digits, in capitals. Short enough for a SKU code of 80 with a size code of 20.
 */
export const itemCode = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z0-9]+$/)
  .max(30);
export const tomorrowColourCode = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z0-9]+$/)
  .max(20);

/** Style-colour fields, reference data by code: the same on a line and on the product. */
export const productFields = {
  styleCode: z.string().optional(),
  styleName: z.string().nullable().optional(),
  styleDescription: z.string().nullable().optional(),
  gender: z.string().nullable().optional(),
  productCategory: z.string().nullable().optional(),
  productSubcategory: z.string().nullable().optional(),
  sizeRunCategory: z.string().nullable().optional(),
  sizeRun: z.string().nullable().optional(),
  colourDescription: z.string().nullable().optional(),
  primaryColour: z.string().nullable().optional(),
  secondaryColour: z.string().nullable().optional(),
  colourCombination: z.string().nullable().optional(),
  materialComposition: z.string().nullable().optional(),
  countryOfOrigin: z.string().nullable().optional(),
};
